'use client';
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from './Tabs';
import { cn } from '@/utils/cn';
import { TabOption } from '@/types';

interface GlobalTabProps {
  className?: string;
  children: React.ReactElement;
  defaultValue: string;
  list: TabOption[];
  handleTrigger: (val: string) => void;
}

const GlobalTab = ({
  className,
  children,
  defaultValue,
  list,
  handleTrigger,
}: GlobalTabProps) => {
  return (
    <Tabs defaultValue={defaultValue} className={cn('w-full', className)}>
      <TabsList>
        {list.map(({ label, value }) => (
          <TabsTrigger
            onClick={() => handleTrigger(value)}
            key={value}
            value={value}
          >
            {label}
          </TabsTrigger>
        ))}
      </TabsList>
      {children}
    </Tabs>
  );
};

export { GlobalTab };
